import * as types from './fe-error-notification-actions-types';
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig';

// FE error log
export const setFeErrorLog = (p) => {
	return {
		type: types.SET_FE_ERROR_LOG,
		payload: p
	}
} 


// Launchdeck Customer Support Requests
export const sendFeErrorMessageSuccess = (response) => {
	return {
		type: types.SEND_FE_ERROR_SLACK_MESSAGE_SUCCESS,
		payload: response.data
	};
};

export const sendFeErrorMessageFailure = (error) => {
	return {
		type: types.SEND_FE_ERROR_SLACK_MESSAGE_FAILURE,
		error
	};
};

export const sendFeErrorMessageRequest = () => {
	return {
		type: types.SEND_FE_ERROR_SLACK_MESSAGE_REQUEST
	};
};

export function sendFeErrorMessage(feMessagePayload) {
	
	return async (dispatch) => {
		dispatch(sendFeErrorMessageRequest());
		try {
			const url = '/support/system-fe-error-message';
			const response = await axiosInstance.post(url, {feMessagePayload}, {});

			dispatch(sendFeErrorMessageSuccess(response));
		} catch (error) {
			dispatch(sendFeErrorMessageFailure(error));
		}
	};
}